module.exports = __webpack_public_path__ + "static/img/newsj.d10f958.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/newsj.png
// module id = y4C5
// module chunks = 45